import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
/*Service*/
import { AppService } from '@services';

/*Config*/
import { CONFIG } from '../../../config';
declare var swal: any;
@Component({
  selector: 'timers-list',
  templateUrl: './timers-list.component.html'
})
export class TimersListComponent implements OnInit {
  periodTimer = CONFIG.periodTimer;
  weekTimer = CONFIG.weekTimer;

  @Output('onDeleteTimer') onDeleteTimer: EventEmitter<any> = new EventEmitter<any>();
  _timersList;
  @Input('timersList') set timersList(value) {
    this._timersList = value;
    this.calcTime();

  }
  constructor(private appService: AppService) { }
  ngOnInit() {
    this.calcTime();
  }
  calcTime() {
    const userDateTimeOffset = this.appService.userTimezoneOffset();
    this._timersList.map(timer => {
      let hours = timer.hours + userDateTimeOffset;
      if (hours >= 24) {
        hours = hours - 24;
      }
      hours = hours.toString();
      if (hours.length === 1) {
        hours = '0' + hours;
      }
      let minutes = timer.minutes.toString();
      if (minutes.length === 1) {
        minutes = '0' + minutes;
      }
      timer['time'] = hours + ':' + minutes;
    });
  }
  getPeriodText(value) {
    return this.periodTimer.filter(period => period.value === value)[0].text;
  }
  removeTimer(timer, index) {
    swal({
      text: 'Удалить таймер?',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: '#23518d',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена'
    }).then((result) => {
      if (result.value) {
        this._timersList.splice(index, 1);
        this.onDeleteTimer.emit(this._timersList);
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/view/components/timers-list/timers-list.component.ts